import { defineParams } from '@sveltejs/kit/params';

export const params = defineParams({
	view: (param) => (param === 'map' || param === 'table' ? param : undefined)
});
